import { useSidebarStore } from "@";

const HideSideBar = () => {
  const { closeSidebar } = useSidebarStore();

  return (
    <div className="m-3 mx-auto flex justify-center lg:hidden">
      <button
        type="button"
        onClick={closeSidebar}
        aria-label="إغلاق القائمة الجانبية"
        className="flex h-10 w-10 items-center justify-center rounded-2xl border border-gray-100 bg-white text-gray-500 shadow-sm transition-all duration-200 hover:scale-105 hover:border-purple-200 hover:bg-purple-50 hover:text-purple-900 active:scale-95 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:border-purple-700 dark:hover:bg-gray-700 dark:hover:text-purple-300"
      >
        <svg
          fill="currentColor"
          viewBox="0 0 20 20"
          className="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
    </div>
  );
};

export default HideSideBar;
